<div class="input-group me-2">
  <ngb-timepicker [(ngModel)]="model" [meridian]="meridian" [spinners]="false" (ngModelChange)="timeChanged($event)"/>
</div>
